import { IdentificationDocumentTypeRepository } from "@core/data/repositories/identification-document-type.repository";
import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { inject, injectable } from "inversify";
import { IdentificationType } from "../models/identification-document-type.model";

@injectable()
export class GetAllIdentificationDocumentTypesUseCase {
    constructor(
        @inject(IdentificationDocumentTypeRepository)
        private readonly identificationDocumentTypeRepository: IdentificationDocumentTypeRepository,
    ) {}

    async execute(): Promise<IdentificationType[]> {
        const identificationDocumentTypesResult =
            await this.identificationDocumentTypeRepository.getAll();

        if (identificationDocumentTypesResult.isLeft()) {
            ToastManagerStore.error(
                identificationDocumentTypesResult.getLeftOrThrow().message,
            );
        }

        return identificationDocumentTypesResult.fold(
            () => [],
            (identificationDocumentTypes) => identificationDocumentTypes,
        );
    }
}
